import SkipContent from './SkipContent';

export default SkipContent;
